import { JUSTE_ENCHERE_CONFIG } from './config'
import type { StoredStats } from './types'

const DEFAULT_STATS: StoredStats = {
  bestQualificationStreak: 0,
  bestFinalTimeMs: null,
  totalRuns: 0,
}

const readStoredStats = (): StoredStats => {
  if (typeof window === 'undefined') return DEFAULT_STATS
  try {
    const raw = window.localStorage.getItem(JUSTE_ENCHERE_CONFIG.storage.key)
    if (!raw) return DEFAULT_STATS
    const parsed = JSON.parse(raw) as StoredStats
    return {
      ...DEFAULT_STATS,
      ...parsed,
    }
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.debug('Unable to read Juste Enchère stats', error)
    }
    return DEFAULT_STATS
  }
}

const writeStoredStats = (stats: StoredStats) => {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(
      JUSTE_ENCHERE_CONFIG.storage.key,
      JSON.stringify(stats),
    )
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.debug('Unable to persist Juste Enchère stats', error)
    }
  }
}

export const updateStoredStats = (
  updater: (prev: StoredStats) => StoredStats,
): StoredStats => {
  const next = updater(readStoredStats())
  writeStoredStats(next)
  return next
}

export { readStoredStats }
